<template>
  <div class="dashboard-container">
    <basic-container>
      <div class="cards-wrapper">
        <div class="card-container">
          <div v-for="(item, index) in option.data" :key="'opt1-' + index" class="custom-card" :style="{ borderTop: `3px solid ${getCardColor(index)}` }" @click="item.click && item.click(item)">
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img v-if="index === 0" src="@/page/login/images/0012.png" class="count-icon" alt="icon" />
              <img v-if="index === 1" src="@/page/login/images/0013.png" class="count-icon" alt="icon" />
              <img v-if="index === 2" src="@/page/login/images/0014.png" class="count-icon" alt="icon" />
              {{ item.count }}
            </p>
          </div>
        </div>

        <div class="card-container">
          <div v-for="(item, index) in option2.data" :key="'opt2-' + index" class="custom-card" :style="{ borderTop: `3px solid ${getCardColor(index)}` }" @click="item.click && item.click(item)">
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img v-if="index === 0" src="@/page/login/images/0015.png" class="count-icon" alt="icon" />
              <img v-if="index === 1" src="@/page/login/images/0016.png" class="count-icon" alt="icon" />
              <img v-if="index === 2" src="@/page/login/images/0017.png" class="count-icon" alt="icon" />
              {{ item.count }}
            </p>
          </div>
        </div>

        <div class="card-container">
          <div v-for="(item, index) in option3.data" :key="'opt3-' + index" class="custom-card" :style="{ borderTop: `3px solid ${getCardColor(index)}` }" @click="item.click && item.click(item)">
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img v-if="index === 0" src="@/page/login/images/0018.png" class="count-icon" alt="icon" />
              <img v-if="index === 1" src="@/page/login/images/0019.png" class="count-icon" alt="icon" />
              <img v-if="index === 2" src="@/page/login/images/0020.png" class="count-icon" alt="icon" />
              <img v-if="index === 3" src="@/page/login/images/0021.png" class="count-icon" alt="icon" />
              {{ item.count }}
            </p>
          </div>
        </div>
        <div class="card-container">
          <div v-for="(item, index) in option4.data" :key="'opt4-' + index" class="custom-card" :style="{ borderTop: `3px solid ${getCardColor(index)}` }" @click="item.click && item.click(item)">
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img v-if="index === 0" src="@/page/login/images/0022.png" class="count-icon" alt="icon" />
              <img v-if="index === 1" src="@/page/login/images/0023.png" class="count-icon" alt="icon" />
              <img v-if="index === 2" src="@/page/login/images/0024.png" class="count-icon" alt="icon" />
              <img v-if="index === 3" src="@/page/login/images/0025.png" class="count-icon" alt="icon" />
              {{ item.count }}
            </p>
          </div>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getIndexCount } from '@/api/health/manage'

export default {
  name: 'Index',
  data() {
    return {
      option: {
        data: [
          {
            title: '用户总人数',
            count: 1662,
            // color: "rgb(27, 201, 142)",
            note: '人'
          },
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: '周注册人数',
            count: 114,
            note: '人'
          },
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '日新注册人数',
            count: 9,
            note: '人'
          }
        ]
      },
      option2: {
        data: [
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '体验会员人数',
            count: 42,
            note: '人'
          },
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '全年会员人数',
            count: 662,
            note: '人'
          },
          {
            click: function (item) {
              // alert('开发中')
            },
            title: 'VIP会员人数',
            count: 162,
            note: '人'
          }
        ]
      },
      option3: {
        data: [
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '亚健康人数',
            count: 728,
            note: '人'
          },
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '慢性病人数',
            count: 128,
            note: '人'
          },
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '重大疾病风险人数',
            count: 48,
            note: '人'
          },
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '危险值报警数',
            count: 78,
            note: '个'
          }
        ]
      },
      option4: {
        data: [
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '家庭医生',
            count: 26,
            note: '人'
          },
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '健康管理护士',
            count: 48,
            note: '人'
          },
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '三级家庭医生咨询总次数',
            count: 128,
            note: '次'
          },
          {
            click: function (item) {
              // alert('开发中')
            },
            title: '认知行为治疗总次数',
            count: 328,
            note: '次'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.onload()
  },
  methods: {
    onload() {
      getIndexCount().then(res => {
        this.option.data[0].count = res.data.count
        this.option.data[1].count = res.data.weekCount
        this.option.data[2].count = res.data.dayCount

        this.option2.data[0].count = res.data.level_2
        this.option2.data[1].count = res.data.level_3
        this.option2.data[2].count = res.data.level_6

        this.option3.data[0].count = res.data.subCount
        this.option3.data[1].count = res.data.chroCount
        this.option3.data[2].count = res.data.riskCount
        this.option3.data[3].count = res.data.abnormalCount
        console.log('count: ', res.data)
      })
    },

    // 动态获取卡片颜色（按顺序循环）
    getCardColor(index) {
      const colors = ['rgb(255, 255, 255)', 'rgb(255, 255, 255)', 'rgb(255, 255, 255)']
      return colors[index % colors.length]
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 防止滚动条出现 */

  .basic-container {
    flex: 1;
    padding: 0.5vh 0; /* 使用视口单位 */
    display: flex;
    flex-direction: column;
    background: transparent; /* 确保容器背景透明 */
    margin: 0 1vw; /* 添加左右margin替代padding */
  }

  .cards-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8vh; /* 使用视口高度的百分比作为行间距 */
    // justify-content: space-between;
    justify-content: space-evenly; /* 更均匀的分布 */
    padding: 5vh 0; /* 添加一些内边距 */
    overflow: hidden; /* 防止内容溢出 */
  }

  .card-container {
    display: flex;
    gap: 2vw; /* 使用视口宽度的百分比作为卡片间距 */
    flex: 1;
    min-height: 0; /* 允许flex item收缩 */
    padding: 0.5vh 0; // 增加行内上下间距方式改为视口宽度
    justify-content: space-around; /* 使用space-around让卡片均匀分布 */
    // justify-content: center; /* 居中卡片 */
    align-items: center; /* 垂直居中 */
    margin: 0 1vw; /* 添加左右margin */
  }

  .custom-card {
    flex: 1;
    // max-width: 20vw; /* 限制卡片最大宽度 */
    min-width: 10vw; /* 设置最小宽度 */
    max-height: 45vh; /* 限制卡片最大高度 */
    height: 13vh;
    background: #fff;
    border-radius: 4px;
    padding: 1.5vh 1.5vw; /* 使用视口单位 */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    // &:hover {
    //   transform: translateY(-5px);
    //   box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1); // 悬停时阴影加深
    // }

    h2 {
      /* 修正选择器从h3改为h2 */
      font-size: clamp(1vw, 1.2vh, 1vw); /* 使用clamp函数设置响应式字体 */
      margin-bottom: 0.5vh;
      color: #000000;
      white-space: nowrap; /* 防止标题换行 */
    }

    p {
      display: flex;
      align-items: center;
      gap: 1vw; /* 使用视口单位 */
      font-size: clamp(18px, 2.5vh, 32px); /* 响应式字体大小 */
      font-weight: bold;
      margin: 0;
      color: #000 !important; /* 数字改为黑色，使用important覆盖内联样式 */

      &::after {
        content: attr(data-note); /* 从data-note属性获取内容 */
        font-size: clamp(12px, 1.2vh, 16px);
        margin-left: 1px;
        font-weight: normal;
        color: #000000;
      }
    }

    .count-icon {
      width: clamp(30px, 4vh, 60px); /* 响应式图标大小 */
      height: clamp(30px, 4vh, 60px);
      object-fit: contain;
    }
  }
}
</style>
